import { render, staticRenderFns } from "./SmsTemplates.vue?vue&type=template&id=be5e7f5a&"
import script from "./SmsTemplates.vue?vue&type=script&lang=ts&"
export * from "./SmsTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports